import { DecoratedPairing } from "@/features-slice/pairings/PairingDTO";

// FIXME agree with new API flags
// export const isPairingOffline = (p: DecoratedPairing) => p.pairingStatus === 'ACTIVE';
export const isPairingOffline = (p: DecoratedPairing) => {
    const { lastSeen, isConnected } = p;
    return !lastSeen || !isConnected || new Date(lastSeen) < new Date(Date.now() - 1000 * 60 * 60 * 24);
}

